import { render, staticRenderFns } from "./add-review-modal.vue?vue&type=template&id=13aabafa&scoped=true"
import script from "./add-review-modal.vue?vue&type=script&lang=js"
export * from "./add-review-modal.vue?vue&type=script&lang=js"
import style0 from "./add-review-modal.vue?vue&type=style&index=0&id=13aabafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aabafa",
  null
  
)

export default component.exports